import React from 'react';
import { Link } from 'react-router-dom';

function Desktop() {
  return (
    <div>
      <h1>Десктоп рецензора</h1>
      <nav>
        <ul>
          <li>
            <Link to="/news">Новини</Link>
          </li>
          <li>
            <Link to="/filters">Фільтри</Link>
          </li>
          <li>
            <Link to="/duplicates">Дублікати</Link>
          </li>
          <li>
            <Link to="/important">Важливі</Link>
          </li>
        </ul>
      </nav>
    </div>
  );
}

export default Desktop;
